<template>
    <div class="toast-manager">
        <transition-group
            tag="div"
            name="toast"
            class="toast-container">
            <toast
                v-for="(toast, index) in toasts"
                :key="`toast-${toast.uid}`"
                :message="toast.message"
                :options="toast.options"
                :onDestroy="toast.onDestroy"
                :position="index"
            ></toast>
        </transition-group>
    </div>
</template>

<script>
import Toast from './Toast';

export default {

    components: {
        Toast
    },
    props: {
        max: { type: Number, default: 3 },
    },

    data() {
        return {
            uid: 1,
            toasts: []
        };
    },

    methods: {
        showToast(theme, message, options) {
            this._addToast(theme, message, options);
            this._moveToast();
        },

        closeAll() {
            this.$nextTick(() => {
                this.toasts = [];
            });
        },

        _addToast(theme, message, options = {}) {
            if (!message) {
                return;
            }

            options = Object.assign({
                theme: theme
            }, options);

            const self = this;
            const uid = this.uid++;
            const toast = {
                uid,
                message,
                options,
                onDestroy() {
                    self._removeToast(uid);
                }
            };

            // Use Vue.nextTick to ensure DOM updates are handled safely
            this.$nextTick(() => {
                this.toasts.unshift(toast);
            });
        },

        _removeToast(uid) {
            const index = this.toasts.findIndex((toast) => toast.uid === uid);
            if (index > -1) {
                this.$nextTick(() => {
                    this.toasts.splice(index, 1);
                });
            }
        },

        _moveToast() {
            const max = this.max > 0 ? this.max : 20;

            this.$nextTick(() => {
                this.toasts = this.toasts.reduceRight((prev, toast, i) => {
                    if (i + 1 > max) {
                        return prev;
                    }

                    return [toast].concat(prev);
                }, []);
            });
        }
    }
};
</script>
